// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthInputCmp$PorterinFeature from "../../../../login/view/components/common/AuthInputCmp.mjs";
import * as CommonHelper$PorterinFeature from "../../../../../shared/core/helpers/CommonHelper.mjs";
import * as DownloadAppVMMapper$PorterinFeature from "../../../view-model/DownloadAppVMMapper.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../domain/store/FareEstimateStoreV1.mjs";
import * as EditBookingDetailsState$PorterinFeature from "../form/EditBookingDetailsState.mjs";
import * as EditBookingDetailsModuleScss from "../../styles/EditBookingDetails.module.scss";
import * as EditBookingDetailsInterface$PorterinFeature from "../form/EditBookingDetailsInterface.mjs";

var styles = EditBookingDetailsModuleScss;

function EditBookingDetailsCmp(Props) {
  var waypoint = Props.waypoint;
  var close_modal = Props.close_modal;
  var sender = Props.sender;
  var receiver = Props.receiver;
  var set_sender = Props.set_sender;
  var set_receiver = Props.set_receiver;
  var match = React.useState(function () {
        return EditBookingDetailsState$PorterinFeature.initialFormState(waypoint === /* Pickup */0 ? sender : receiver);
      });
  var setInitialInput = match[1];
  var match$1 = React.useState(function () {
        
      });
  var response = match$1[0];
  var form = EditBookingDetailsInterface$PorterinFeature.Form.useForm(match[0], (function (output, callbacks) {
          EditBookingDetailsState$PorterinFeature.onFormSubmit(output, waypoint, close_modal, [
                sender,
                set_sender
              ], [
                receiver,
                set_receiver
              ]);
        }));
  var getFieldError = function (field, _callback) {
    Curry._1(form.dirty, undefined);
    return CommonHelper$PorterinFeature.getError(field);
  };
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG !== /* Submitting */0) {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setInitialInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  var match$2 = Curry._1(form.dirty, undefined);
  var tmp;
  tmp = response !== undefined && !(response.TAG === /* Ok */0 || match$2) ? React.createElement("div", {
          className: styles["submit-button-error"]
        }, response._0) : null;
  return React.createElement("div", {
              className: styles["edit-booking-details-wrapper"]
            }, React.createElement("div", {
                  className: styles["edit-form-wrapper"]
                }, React.createElement("form", {
                      className: styles["signup-form"],
                      onSubmit: (function ($$event) {
                          $$event.preventDefault();
                          Curry._1(form.submit, undefined);
                        })
                    }, React.createElement("div", {
                          className: styles["field-wrapper"]
                        }, React.createElement(AuthInputCmp$PorterinFeature.make, {
                              label: "House / Apartment (optional)",
                              is_required: false,
                              is_filled: form.input.house_address.length === 0,
                              children: React.createElement("input", {
                                    className: styles["mobile-input"],
                                    autoFocus: DownloadAppVMMapper$PorterinFeature.isIOS(undefined) ? false : true,
                                    disabled: form.submitting,
                                    placeholder: "",
                                    type: "text",
                                    value: form.input.house_address,
                                    onBlur: (function (param) {
                                        Curry._1(form.blurName, undefined);
                                      }),
                                    onChange: (function ($$event) {
                                        Curry._2(form.updateHouse_address, (function (input, value) {
                                                return {
                                                        house_address: value,
                                                        name: input.name,
                                                        mobile: input.mobile
                                                      };
                                              }), $$event.target.value);
                                      })
                                  }),
                              error: getFieldError(form.house_addressResult, (function (field_errors) {
                                      return field_errors.house_address;
                                    })),
                              styles: styles,
                              clear_input: (function ($$event) {
                                  Curry._2(form.updateHouse_address, (function (input, param) {
                                          return {
                                                  house_address: "",
                                                  name: input.name,
                                                  mobile: input.mobile
                                                };
                                        }), $$event.target.value);
                                }),
                              show_clear_icon: true
                            }), React.createElement("div", {
                              className: styles.spacing
                            }), React.createElement(AuthInputCmp$PorterinFeature.make, {
                              label: "Name",
                              is_required: true,
                              is_filled: form.input.name.length === 0,
                              children: React.createElement("input", {
                                    className: styles["mobile-input"],
                                    disabled: form.submitting,
                                    placeholder: "",
                                    type: "text",
                                    value: form.input.name,
                                    onBlur: (function (param) {
                                        Curry._1(form.blurName, undefined);
                                      }),
                                    onChange: (function ($$event) {
                                        Curry._2(form.updateName, (function (input, value) {
                                                return {
                                                        house_address: input.house_address,
                                                        name: value,
                                                        mobile: input.mobile
                                                      };
                                              }), $$event.target.value);
                                      })
                                  }),
                              error: getFieldError(form.nameResult, (function (field_errors) {
                                      return field_errors.name;
                                    })),
                              styles: styles,
                              clear_input: (function ($$event) {
                                  Curry._2(form.updateName, (function (input, param) {
                                          return {
                                                  house_address: input.house_address,
                                                  name: "",
                                                  mobile: input.mobile
                                                };
                                        }), $$event.target.value);
                                }),
                              show_clear_icon: true
                            }), React.createElement("div", {
                              className: styles.spacing
                            }), React.createElement(AuthInputCmp$PorterinFeature.make, {
                              label: "Mobile",
                              is_required: true,
                              is_filled: form.input.mobile.length === 0,
                              children: React.createElement("input", {
                                    className: styles["mobile-input"],
                                    disabled: form.submitting,
                                    maxLength: 10,
                                    placeholder: "",
                                    type: "tel",
                                    value: form.input.mobile,
                                    onBlur: (function (param) {
                                        Curry._1(form.blurMobile, undefined);
                                      }),
                                    onChange: (function ($$event) {
                                        Curry._2(form.updateMobile, (function (input, value) {
                                                return {
                                                        house_address: input.house_address,
                                                        name: input.name,
                                                        mobile: value
                                                      };
                                              }), $$event.target.value);
                                      })
                                  }),
                              error: getFieldError(form.mobileResult, (function (field_errors) {
                                      return field_errors.mobile;
                                    })),
                              styles: styles,
                              clear_input: (function ($$event) {
                                  Curry._2(form.updateMobile, (function (input, param) {
                                          return {
                                                  house_address: input.house_address,
                                                  name: input.name,
                                                  mobile: ""
                                                };
                                        }), $$event.target.value);
                                }),
                              show_clear_icon: true
                            })))), React.createElement("div", {
                  className: styles["save-details-wrapper"]
                }, React.createElement("button", {
                      className: styles["save-details"],
                      disabled: !Curry._1(form.valid, undefined) || form.submitting,
                      onClick: (function (param) {
                          Curry._1(form.submit, undefined);
                        })
                    }, FareEstimateStoreV1$PorterinFeature.edit_booking_details_button), React.createElement("div", {
                      className: styles["form-error-container"]
                    }, tmp)));
}

var make = EditBookingDetailsCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
